var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { createProduct, fetchProductsByTitleId, } from "../../api/productService";
import { navigation } from "../../components/navigation";
import { ProductAccessibilityEnum } from "../../types/Api";
import ProductForm from "./ProductForm";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { defaultPublishingStatus, firstOnix } from "../../utils/selectMappers";
import { getLockedPrimaryContentType } from "../../utils/onixDependencies";
import { defaultPrimaryContentType } from "../../utils/productContentType";
var ProductCreate = function () {
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var searchParams = new URLSearchParams(location.search);
    var titleId = searchParams.get("titleId");
    useEffect(function () {
        if (!titleId) {
            history.replace(navigation.products.path);
        }
    }, [titleId, history]);
    var _a = useOnixOptions(), primaryContentTypeTable = _a.primaryContentTypeTable, compositionTable = _a.compositionTable, publishingStatusTable = _a.publishingStatusTable;
    var existingProducts = useQuery(["products", titleId], function () { return fetchProductsByTitleId(ky, titleId); }, { enabled: !!titleId }).data;
    if (!titleId) {
        return null;
    }
    // All products of one title must share the same primary content type. When the
    // title already has a product, pre-fill the field with that type (still editable
    // — a mismatch on save is caught with an info dialog and the backend guard).
    var requiredPrimaryContentType = getLockedPrimaryContentType(existingProducts === null || existingProducts === void 0 ? void 0 : existingProducts.items);
    var initialValues = {
        title: { id: titleId },
        ownerId: undefined,
        // Locked type (title already has a product) → Text (81/10) → empty; never
        // the first codetable item. Shared with the title panel's create modal.
        primaryContentType: defaultPrimaryContentType(primaryContentTypeTable, requiredPrimaryContentType),
        // Left empty on purpose (as in the title panel's create modal) so the user
        // consciously picks the binding instead of accepting the first item.
        form: undefined,
        formDetails: [],
        unitMeasures: undefined,
        cartonMeasures: undefined,
        palletMeasures: undefined,
        extents: [],
        composition: firstOnix(compositionTable),
        publishingStatus: defaultPublishingStatus(publishingStatusTable),
        publishingDate: "",
        copyrightFrom: "",
        copyrightTo: "",
        price: undefined,
        accessibility: ProductAccessibilityEnum.PRIVATE,
        publicTime: undefined,
    };
    var handleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var createdProduct;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createProduct(ky, data)];
                case 1:
                    createdProduct = _a.sent();
                    if (createdProduct === null || createdProduct === void 0 ? void 0 : createdProduct.id) {
                        history.push("/bragency/products?detail=".concat(createdProduct.id));
                    }
                    else if (navigation.products) {
                        history.push(navigation.products.path);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(ProductForm, { initialValues: initialValues, onSubmit: handleSubmit, title: formatMessage({
            id: "ui-br-agency.product.create.pane.title",
        }), titleId: titleId, requiredPrimaryContentTypeValue: requiredPrimaryContentType === null || requiredPrimaryContentType === void 0 ? void 0 : requiredPrimaryContentType.value }));
};
export default ProductCreate;
